module.exports = __webpack_public_path__ + "static/media/Login_Box_Pop.d94c4af0.png";